import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { NgbCollapseModule, NgbDatepickerModule, NgbTimepickerModule, NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { ClickOutsideModule } from 'ng-click-outside';

import { PagetitleComponent } from './pagetitle/pagetitle.component';
import { LoaderComponent } from './loader/loader.component';
import { SellingChartComponent } from './selling-chart/selling-chart.component';
import { NgApexchartsModule } from 'ng-apexcharts';
// import { NgApexchartsModule } from 'ng-apexcharts';

@NgModule({
  declarations: [PagetitleComponent, LoaderComponent, SellingChartComponent],
  imports: [
    CommonModule,
    FormsModule,
    ClickOutsideModule,
    NgbCollapseModule,
    NgbDatepickerModule,
    NgbTimepickerModule,
    NgbDropdownModule,
    NgApexchartsModule
  ],
  exports: [PagetitleComponent,LoaderComponent, SellingChartComponent]
})
export class UIModule { }
